// 구독 Plan 상수

export interface PlanItem {
    name: string;
    value: keyof typeof Plan;
    price: number;
    point?: number;
    token?: number;
    isAddUser?: boolean;
}

export const Plan = {
    FREE: "FREE",
    PRO: "PRO",
    BASIC: "BASIC",
    AI_PACKAGE: "AI_PACKAGE",
} as const;

export const Plans: { [K in keyof typeof Plan]: PlanItem } = {
    FREE: {
        name: "무료",
        price: 0,
        value: Plan.FREE,
    },
    PRO: {
        name: "프로",
        price: 9900,
        point: 3000,
        token: 1,
        value: Plan.PRO,
    },
    BASIC: {
        name: "베이직",
        price: 44000,
        point: 5000,
        value: Plan.BASIC,
        isAddUser: true,
    },
    AI_PACKAGE: {
        name: "AI 패키지",
        price: 66000,
        point: 10000,
        token: 5,
        value: Plan.AI_PACKAGE,
        isAddUser: true,
    },
} as const;

export const TokenType = {
    USE: "토큰 사용",
    ADD: "토큰 적립",
    SUBTRACT: "토큰 차감",
    EXPIRE: "토큰 소멸",
    REFUND: "토큰 환불",
} as const;

export const PointType = {
    USE: "포인트 사용",
    ADD: "포인트 적립",
    SUBTRACT: "포인트 차감",
    EXPIRE: "포인트 소멸",
    REFUND: "포인트 환불",
} as const;
